import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettings } from '../config/app-settings';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  recurso: string = '/session';

  constructor(private http: HttpClient) { }

  login(data: any): Observable<any> {
    return this.http.post(AppSettings.API_URI_PUBLIC + this.recurso + '/login', data);
  }

  logout(): Observable<any> {
    return this.http.post(AppSettings.API_URI_PUBLIC + this.recurso + '/logout',{});
  }

  solicitud(data: any): Observable<any> {
    return this.http.post(AppSettings.API_URI_PUBLIC + this.recurso + '/restaurar-clave',data);
  }

  confirmar(data: any): Observable<any> {
    return this.http.post(AppSettings.API_URI_PUBLIC + this.recurso + '/restaurar-clave/confirmar',data);
  }

}
